import { ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { generateMockPackages } from "@/features/supervision-cards-list";
import { LinkMessagesModal } from "../link-messages-modal";

export function openLinkMessagesModal(sourceId: string) {
  // eslint-disable-next-line no-console
  console.log("openLinkMessagesModal: id", sourceId);

  const container = document.createElement("div");
  document.body.appendChild(container);
  const root = createRoot(container);

  const handleClose = () => {
    setTimeout(() => {
      root.unmount();
      container.remove();
    }, 0);
  };

  const data = generateMockPackages(50);

  root.render((
    <LinkMessagesModal open onClose={handleClose} data={data} />
  ) as ReactNode);
}

